module.exports = __webpack_public_path__ + "img/image34.c7712a9e.png";